import "./header.scss";
import logo from "../../assets/header_logo.png";
import CustomButton from "../../components/custom-button";
import { Link, NavLink } from "react-router-dom";

const Header = () => {

  return (
    <header className="main-menu header-container ">
      <div className="main-container">
        <ul className="shawi-navbar-image">
          <Link className="navbar-brand" to={"/home"} >
            {" "}
            <img id="header-logo" src={logo} alt="logo" className="logo-image-header" />
          </Link>
        </ul>
        <ul className="shawi-navbar-list">
          <li>
            {" "}
            <NavLink to={"/home"} className="shawi-navbar-list-item " activeClassName="current-item"  >الرئيسية</NavLink>{" "}
          </li>
          <li>
            {" "}
            <NavLink to={"/about"}  className="shawi-navbar-list-item" activeClassName="current-item">عن المؤسسة</NavLink>{" "}
          </li>
          <li>
            {" "}
            <NavLink to={"/media"}  className="shawi-navbar-list-item" activeClassName="current-item">المركز الإعلامي</NavLink>{" "}
          </li>
          <li>
            {" "}
            <NavLink to={"/news"}  className="shawi-navbar-list-item" activeClassName="current-item">أخبارنا</NavLink>{" "}
          </li>
          <li>
            {" "}
            <NavLink to={"/contact"}  className="shawi-navbar-list-item" activeClassName="current-item">تواصل معنا </NavLink>{" "}
          </li>
        </ul>
        <ul className="shawi-navbar-button">
          <NavLink to={"/login"}>
            {" "}
            <CustomButton classes="shawi-login-btn" title="تسجيل الدخول " />
          </NavLink>
        </ul>
      </div>
    </header>
  );
};

export default Header;
